<template>
  <v-container>
    <h2 class="text-h5 mb-4">Treinamentos e Comunicados</h2>
    <v-row>
      <v-col
        v-for="video in videos"
        :key="video.id"
        cols="12" md="4"
      >
        <v-card class="rounded-xl">
          <v-responsive aspect-ratio="16/9">
            <iframe
              v-if="video.video_url_embed"
              :src="video.video_url_embed"
              frameborder="0"
              allowfullscreen
              class="w-full h-full"
            ></iframe>
          </v-responsive>
          <v-card-title>{{ video.title }}</v-card-title>
          <v-card-text>{{ video.description }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-right mt-2">
      <v-btn variant="text" color="primary" @click="goToAllVideos">
        Ver todos
      </v-btn>
    </div>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import api from "@/services/api";
import { useRouter } from "vue-router";
import { useLoadingOverlay } from "@/store/loadingOverlay";

const videos = ref([]);
const router = useRouter();
const loadingOverlay = useLoadingOverlay();

const loadVideos = async () => {
  loadingOverlay.startLoading();
  try {
    const response = await api.get("/videos",{
      params: {
        type: 'internal'
      }
    });
    videos.value = response.data.data;
  } catch (error) {
    console.error("Erro ao carregar vídeos:", error);
    toastStore.showToast({
      message:
        error?.response?.data?.error ||
        "Ocorreu um erro ao carregar a lista de vídeos.",
      color: "error",
    });
  } finally {
    loadingOverlay.stopLoading();
  }
};

const goToAllVideos = () => {
  router.push("/training-videos");
};

onMounted(loadVideos);
</script>
